import _has from 'lodash/has'
// import _forEach from 'lodash/forEach'

export const options = {
  namespaced: true,
  state: () => ({
    error: null,
    products: []
  }),
  getters: {
    products (state) {
      return state.products
    }
  },
  mutations: {
    productsLoaded: function (state, products) {
      state.error = null
      state.products = products.filter(product => product.isOption)
    }
  },
  actions: {
    loadProducts ({ commit, dispatch }) {
      return this.$app.axios.get('/product/get', {
      }).then(function (response) {
        // Erfolgreiche Authentifizierung
        commit('productsLoaded', response.data)
      })
        .catch((error) => {
          // Es soll trotz eines 401 den Error aus dem Response Body angezeigt werden
          if (error.response && error.response.status === 401) {
            const data = error.response.data
            if (_has(data, 'message')) {
              commit('authenticatingError', data.message)
            } else {
              // Sollte nicht eintreten, malformed json response
              commit('authenticatingError', error)
            }
          } else {
            // Anderer HTTP-Status-Code (zum Beispiel 500)
            commit('authenticatingError', error)
          }
        })
    }
  }
}
